<h4 [ngClass]="{'black-text': isTextBlack}">{{text}}</h4>